import {Component} from '@angular/core';

// DEV NOTE: It's preferable to put icons in the /assets/icons folder instead of creating a component for each icon since this increases
// the bundle size. This is an exception because I needed to color the icon according to the text

@Component({
    selector: 'app-icon-close',
    templateUrl: './icon-close.component.svg',
    standalone: false
})
export class IconCloseComponent {
}
